//classNamee  che gestisce gli elementi primary
import React, { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';
//import { createBrowserHistory as history } from 'history';
//import { useHistory } from 'react-router-dom';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { withRouter } from 'react-router';
import './headerComponent.css';
import AutenthicationService from '../services/authservice.js';
import { Redirect, Route } from 'react-router-dom';
const HeaderComponent = (props) => {
  // state = {
  //   isToken: false,
  //   path: '/cancello',
  // };
  console.log(AutenthicationService.isLogged());
  const { history } = props;

  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [iscancello, setDisableCancello] = useState(false);
  const [iscaldaia, setDisableCaldaia] = useState(false);
  const [isluce, setDisableLuce] = useState(false);
  const [isalim, setDisableAlim] = useState(false);

  
  
  const [islogin, setDisableLogin] = useState(false);
  const [isutente, setDisableUtente] = useState(false);
  const [isonoff, setDisableOnOff] = useState(false);

  useEffect(() => {
   // if (history) history.push('/');
    console.log('useEffect : init history');
  }, []);

  const setAzione = (event) => {
    let token = AutenthicationService.isLogged();
    let azione = '';
    console.log('setAzione : ', [event.target.name], ' ', [event.target.value]);
debugger;
    switch (event.target.id) {
      case 'cancello':
        setIsNavCollapsed(true);
        setDisableCancello(true);
        setDisableCaldaia(false);
        setDisableUtente(false);
        setDisableOnOff(false);
        setDisableLuce(false);
        setDisableLogin(true);
        if (token) {
          azione = event.target.id;
        } else {
          azione = '/login/cancello';
        }
        if (history) history.push(azione);
        break;
      case 'cancello1' :
        setIsNavCollapsed(true);
        setDisableCaldaia(false);
        setDisableCancello(false);
        setDisableUtente(false);
        setDisableLuce(false);
        setDisableLogin(true);
        setDisableOnOff(true);
        if (token) {
          azione = event.target.id;
        } else {
          azione = '/login/onoff';
        }
        if (history) history.push(azione);
        break;  
      case 'caldaia':
        setIsNavCollapsed(true);
        setDisableCaldaia(true);
        setDisableCancello(false);
        setDisableUtente(false);
        setDisableLogin(true);
        setDisableLuce(false);
        if (token) {
          azione = event.target.id;
        } else {
          azione = '/login/caldaia';
        }
        if (history) history.push(azione);
        break;
        
        case 'luce':
          setIsNavCollapsed(true);
          setDisableCaldaia(false);
          setDisableCancello(false);
          setDisableUtente(false);
          setDisableLogin(true);
          setDisableLuce(true);
          if (token) {
            azione = event.target.id;
          } else {
            azione = '/login/luce';
          }
          if (history) history.push(azione);
          break;

        case 'alim':
          setIsNavCollapsed(true);
          setDisableCaldaia(false);
          setDisableCancello(false);
          setDisableUtente(false);
          setDisableLogin(true);
          setDisableLuce(false);
          setDisableAlim(true);
          if (token) {
            azione = event.target.id;
            console.log("azione: ", azione);
          } else {
            azione = '/login/alim';
          }
          if (history) history.push(azione);
          break;
      case 'login':
        setIsNavCollapsed(true);
        setDisableLogin(true);
        if (token) {
          break;
        }
        setDisableCaldaia(false);
        setDisableCancello(false);
        setDisableUtente(false);
        setDisableLuce(false);
        if (history) history.push('/login/login');
        break;
      case 'home':
        setIsNavCollapsed(true);
        setDisableCancello(false);
        setDisableCaldaia(false);
        setDisableOnOff(false);
        setDisableLogin(false);
        setDisableUtente(false);
        setDisableLuce(false);
        setDisableAlim(false);
        if (token) {
          setDisableLogin(true);
        } else {
          setDisableLogin(false);
        }
        break;
      case 'utente':
        setIsNavCollapsed(true);
        setDisableCancello(false);
        setDisableCaldaia(false);
        setDisableOnOff(false);
        setDisableLuce(false);
        setDisableLogin(true);
        setDisableUtente(true);
        if (token) {
          azione = event.target.id;
        } else {
          azione = '/login/utente';
        }
        if (history) history.push(azione);

        break;
      case 'logout':
        setIsNavCollapsed(true);
        setDisableCancello(false);
        setDisableCaldaia(false);
        setDisableOnOff(false);
        setDisableLogin(false);
        setDisableUtente(false);
        setDisableLuce(false);
        break;
      default:
        console.log('nessuna referenza x switch ', event.target.name);
        break;
    }
  };
  const onFocus = (e) => {
    e.target.blur();
  };
  const handleNavCollapse = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };
  const handleSelect = (eventKey) => {
    console.log(`selected ${eventKey}`);
    if (history) history.push(eventKey);
  };

  return (
    <div className='HeaderComponent'>
      {/* <nav className='navbar navbar-expand-lg navbar-light bg-light rounded'> */}
      <Navbar
        className='navbar navbar-expand-md navbar-dark fixed-top bg-dark
        '
        collapseOnSelect
        expand='lg'
        onSelect={handleSelect}
      >
        <nav className='navbar navbar-expand-md navbar-dark fixed-top bg-dark'>
          <a className='navbar-brand text-info font-weight-bolder' href='/'>
            {/* <img
            // src={Logo}
            alt='Logo'
            width='36'
            height='36'
            className='vertical-align-middle'
          /> */}
            <i className='fas fa-user-circle'>
              <UserInfo />
              {/* <span id='ragsoclie'>
                {AutenthicationService.getUserInfo() && (
                  <div>{AutenthicationService.getUserInfo()} </div>
                )}
              </span> */}
            </i>
          </a>

          <button
            className='custom-toggler navbar-toggler'
            type='button'
            data-toggle='collapse'
            data-target='#navbarsExample09'
            aria-controls='navbarsExample09'
            aria-expanded={!isNavCollapsed ? true : false}
            aria-label='Toggle navigation'
            onClick={handleNavCollapse}
          >
            <span className='navbar-toggler-icon'></span>
          </button>

          <div
            className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`}
            id='navbarsExample09'
          >
            <Nav className='mr-auto'>
              <Link
                //  className='nav-link text-info'
                to='/'
                id='home'
                name='home'
                className='btn btn-success active m-1'
                //onClick={setAttivaButton}
                onClick={setAzione}
                onFocus={onFocus}
              >
                <i className='fa fa-home m-1' id='home'></i>
                Home
              </Link>

              <button
                //   className='nav-link text-info'
                //to='/login'
                type='button'
                name='login'
                id='login'
                className='btn btn-primary m-1'
                onClick={setAzione}
                disabled={islogin}
                onFocus={onFocus}
              >
                <i className='fas fa-address-card m-1' id='login'></i>
                Login
              </button>
              <Link
                // className='nav-link'
                to='/logout'
                type='button'
                name='logout'
                id='logout'
                className='btn btn-info m-1'
                onClick={setAzione}
                onFocus={onFocus}
              >
                <i className='fas fa-address-card m-1' id='logout'></i>
                Logout
              </Link>
              <button
                type='button'
                name='cancello'
                id='cancello'
                onClick={setAzione}
                className='btn btn-danger m-1'
                disabled={iscancello}
                onFocus={onFocus}
              >
                <i className='fas fa-dice-six m-1' id='cancello'></i>
                Cancello
              </button>
              <button
                type='button'
                name='cancello1'
                id='cancello1'
                onClick={setAzione}
                onFocus={onFocus}
                disabled={isonoff}
                className='btn btn-warning btn-light m-1'
              >
                <i className='fas fa-car m-1' id='cancello1'></i>
                 OnOff
              </button>
              <button 
                type='button'
                name='caldaia'
                id='caldaia'
                onClick={setAzione}
                onFocus={onFocus}
                disabled={iscaldaia}
                className='btn btn-warning m-1'
              >
                <i className='fas fa-snowflake m-1' id='caldaia'></i>
                Caldaia
              </button>
              <button 
                type='button'
                name='luce'
                id='luce'
                onClick={setAzione}
                onFocus={onFocus}
                disabled={isluce}
                className='btn btn-google m-1'
              >
                <i className='fa fa-eye m-1' id='luce'></i>
                Luce
              </button>
              <button 
                type='button'
                name='alim'
                id='alim'
                onClick={setAzione}
                onFocus={onFocus}
                disabled={isalim}
                className='btn btn-outline-danger m-1'
              >
                <i className='fa fa fa-bolt m-1' id='alim'></i>
                Alimentatore
              </button>
              <NavDropdown title='Dropdown' id='collasible-nav-dropdown'>
                <NavDropdown.Item onClick={() => handleSelect('/welcome')}>
                  Welcome
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => handleSelect('/clitab')}>
                CliTab
                </NavDropdown.Item>
                <NavDropdown.Item href='#action/3.3'>
                  Something
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href='#action/3.4'>
                  Separated link
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <button
              // eventKey={2}
              // to='/clienti'
              type='button'
              // type='submit'
              name='utente'
              id='utente'
              disabled={isutente}
              onClick={setAzione}
              onFocus={onFocus}
              //onClick={() => this.props.history.push('/clienti')}
              className='btn btn-outline-success my-2 my-sm-0 m-1'
            >
              <i className='fas fa-dice-six m-1' id='utente'></i>
              Utente
            </button>
          </div>
        </nav>
      </Navbar>
    </div>
  );
};

export default withRouter(HeaderComponent);

const UserInfo = () => {
  debugger;
  if (AutenthicationService.isLogged()) {
    return (
      <span id='ragsoclie'>
        &nbsp;Benvenuto {AutenthicationService.getUserInfo()}
      </span>
    );
  } else {
    return <span id='ragsoclie'>Eseguire il Login</span>;
  }
};
